/**
 * Helper: GraphQL
 * -----------------------------------------------------------------------------
 * Handles GraphQL responses.
 * - Add in alphabetical order.
 *
 */

/**
 * Decodes Shopify API IDs into Liquid format IDs.
 * @param {String} string - Encoded string.
 * @returns {String}
 */
export function decodeApiId(string) {
  if (!string) {
    return null
  }

  return Number(string.split('/').pop())
}

/**
 * Removes edges and nodes from GraphQL data.
 * @param {Object} object - GraphQL data.
 * @param {String} field - Optional string to filter by.
 * @returns {Object}
 */
export function transformEdges(object, field) {
  if (!object) {
    return []
  }

  if (!field) {
    return object.edges.map((edge) => {
      return edge.node
    })
  }

  return object.edges.map((edge) => {
    return edge.node[field]
  })
}

/**
 * Format richtext metafield object value content into HTML.
 * @param {Object} content - Richtext metafield from GQL
 * @returns {String}
 */
export function richtextToHtml(content) {
  const parsed = JSON.parse(content)
  let html = ''
  parsed.children.forEach((node) => {
    switch (node.type) {
      case 'heading':
        html += `<h${node.level}>${node.children[0].value}</h${node.level}>`
        break
      case 'list':
        html += `<${node.listType === 'unordered' ? 'ul' : 'ol'}>`
        node.children.forEach((item) => {
          html += `<li>${item.children[0].value}</li>`
        })
        html += `<${node.listType === 'unordered' ? '/ul' : '/ol'}>`
        break
      case 'paragraph':
        html += `<p>`
        node.children.forEach((item) => {
          if (item.type === 'text' && item.bold) {
            html += `<strong>${item.value}</strong> `
          } else if (item.type === 'text' && item.italic) {
            html += `<em>${item.value}</em> `
          } else if (item.type === 'text') {
            html += `${item.value} `
          }
          if (item.type === 'link' && item.bold) {
            html += `<a href="${item.url}" target="${item.target}"><strong>${item.children[0].value}</strong></a> `
          } else if (item.type === 'link' && item.italic) {
            html += `<a href="${item.url}" target="${item.target}"><em>${item.children[0].value}</em></a> `
          } else if (item.type === 'link') {
            html += `<a href="${item.url}" target="${item.target}">${item.children[0].value}</a> `
          }
        })
        html += `</p>`
        break
    }
  })

  return html
}

/**
 * Get metaobject field value by key.
 * @param {Array} fields - Unformatted field objects
 * @param {String} key - Key to get
 * @returns {Boolean|String|null}
 */
export function getFieldValueByKey(fields, key) {
  if (!fields || !fields.length) {
    return null
  }

  const matchedField = fields.find(field => field?.key === key)

  if (!matchedField) {
    return null
  }

  if (matchedField?.type === 'boolean') {
    return matchedField?.value === 'true'
  }

  // if (matchedField?.references?.edges?.length > 0) {
  //   return transformEdges(matchedField.references)
  // }

  // if (matchedField?.reference) {
  //   return matchedField.reference
  // }

  return matchedField?.value

}

/**
 * Get array from string metafield values.
 * @param {String} string
 * @returns {Array}
 */
export function getArrayFromString(string) {
  if (!string) {
    return []
  }

  return string?.replace(/\[|\]|'|"/g, '').split(',') || []
}
